import { configureStore } from "@reduxjs/toolkit";
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import themeReducer from "../modules/global/slice/index";
import { itenaryApi } from "../modules/itenary/queries/itenaryQueries";
import { quotationApi } from "../modules/quotation/queries/quotationQueries";
import { hotelApi } from "../modules/hotel/queries/hotelQueries";
import { loginApi } from "../modules/login/queries/loginQueries";
import { rejectQuoteApi } from "../modules/rejectedQuote/queries/rejectQueries";
import { tourApi, viewEditTourApi } from "../modules/tour/queries/tourQueries";
import { itineraryApi } from "../modules/tour/queries/itineraryQueries";
import { adminQuotationApi } from "../modules/adminQuotation/queries/adminQuotationQueries";
import { activityCategoryApi } from "../modules/activityCategory/queries/activityCategoryQueries";
import { tourAreaApi } from "../modules/tourArea/queries/tourAreaQueries";
import { adminQrApi } from "../modules/adminQr/queries/adminQrQueries";
import { blogApi } from "../modules/blogs/queries/blogQueries";
import { offerApi } from "../modules/offers/queries/offerQueries";
import { userApi } from "../modules/users/queries/userQueries";
import { metaDataApi } from "../modules/metaData/queries/metaDataQueries";

const store = configureStore({
  reducer: {
    theme: themeReducer,
    [itenaryApi.reducerPath]: itenaryApi.reducer,
    [quotationApi.reducerPath]: quotationApi.reducer,
    [hotelApi.reducerPath]: hotelApi.reducer,
    [loginApi.reducerPath]: loginApi.reducer,
    [rejectQuoteApi.reducerPath]: rejectQuoteApi.reducer,
    [tourApi.reducerPath]: tourApi.reducer, 
    [viewEditTourApi.reducerPath]: viewEditTourApi.reducer,
    [itineraryApi.reducerPath]: itineraryApi.reducer,
    [adminQuotationApi.reducerPath]: adminQuotationApi.reducer,
    [activityCategoryApi.reducerPath]: activityCategoryApi.reducer,
    [tourAreaApi.reducerPath]: tourAreaApi.reducer,
    [adminQrApi.reducerPath]: adminQrApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [offerApi.reducerPath]: offerApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [metaDataApi.reducerPath]: metaDataApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(
      itenaryApi.middleware,
      hotelApi.middleware,
      quotationApi.middleware,
      loginApi.middleware,
      rejectQuoteApi.middleware,
      tourApi.middleware,
      viewEditTourApi.middleware,
      itineraryApi.middleware,
      adminQuotationApi.middleware,
      activityCategoryApi.middleware,
      tourAreaApi.middleware,
      adminQrApi.middleware,
      blogApi.middleware,
      offerApi.middleware,
      userApi.middleware,
      metaDataApi.middleware,
    ),
});

export default store;
